export default {
  primary: '#7ED321',
};
